import { Scalar } from "../../math";
import { IsDrawableTileMapLayer, TileMapBase } from "../../tiles";
export class Context2DTileMap extends TileMapBase {
    constructor(display, nav) {
        super(display, nav);
    }
    draw(ctx, xoffset = 0, yoffset = 0) {
        const navigation = this.navigationState;
        if (!navigation) {
            return;
        }
        if (!ctx || !this._display) {
            return;
        }
        if (!this._layerViews.count) {
            return;
        }
        const display = this.display;
        if (!display) {
            return;
        }
        ctx.save();
        try {
            const x = xoffset;
            const y = yoffset;
            const w = display.resolution.width;
            const h = display.resolution.height;
            const scale = this.navigationState?.scale ?? 1.0;
            ctx.clearRect(x, y, w, h);
            ctx.translate(x + w / 2, y + h / 2);
            if (this.navigationState?.azimuth?.value) {
                const angle = this.navigationState.azimuth.value * Scalar.DEG2RAD;
                ctx.rotate(angle);
            }
            ctx.scale(scale, scale);
            for (const view of this._layerViews) {
                const layer = view.layer;
                if (!layer.enabled) {
                    continue;
                }
                const render = IsDrawableTileMapLayer(layer) ? layer.drawFn?.bind(layer.drawTarget ?? layer) : undefined;
                if (!render) {
                    continue;
                }
                const currentLod = navigation.lod;
                const lat = navigation.center.lat;
                const lon = navigation.center.lon;
                const metrics = layer.metrics;
                const center = metrics.getLatLonToPointXY(lat, lon, currentLod);
                const size = metrics.tileSize;
                const tiles = view.activTiles;
                for (const tile of tiles) {
                    const b = tile?.boundingBox;
                    if (!b || !tile.content) {
                        continue;
                    }
                    const dlod = currentLod - tile.address.levelOfDetail;
                    const lodScaling = dlod == 0 ? 1 : dlod < 0 ? 1 << dlod : 1 / (1 << dlod);
                    const x = b.x * lodScaling - center.x;
                    const y = b.y * lodScaling - center.y;
                    ctx.save();
                    try {
                        ctx.translate(x, y);
                        ctx.scale(lodScaling, lodScaling);
                        render(ctx, tile, size, size);
                    }
                    finally {
                        ctx.restore();
                    }
                    continue;
                }
            }
        }
        finally {
            ctx.restore();
        }
    }
}
//# sourceMappingURL=map.context2d.js.map